import { ListItem, TableRow, Typography, styled } from "@mui/material";

export const StyledBaseRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    "&:first-of-type": {
      width: 290,
    },
    "&:not(:first-of-type)": {
      minWidth: 430,
      borderLeft: `1px solid ${theme.palette.neutrals.neutral_300}`,
    },
  },
}));

export const StyledTableRow = styled(StyledBaseRow, {
  shouldForwardProp: (prop) =>
    !["isWhite", "isCustom"].includes(prop as string),
})<{ isWhite?: boolean }>(({ theme, isWhite }) => ({
  backgroundColor: isWhite ? "white" : theme.palette.neutrals.neutral_50,
  ".MuiTableCell-root:first-of-type": {
    backgroundColor: isWhite ? "white" : theme.palette.neutrals.neutral_50,
  },
}));

export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) =>
    !["justifyContent", "fontWeight"].includes(prop as string),
})<{ justifyContent: string; fontWeight?: string; component?: any }>(
  ({ theme, justifyContent = "flex-start", fontWeight }) => ({
    flex: 1,
    borderBottom: "none",
    fontSize: theme.typography.small.fontSize,
    display: "flex",
    alignItems: "center",
    justifyContent,
    padding: 0,
    fontWeight,
  }),
);

export const StyledTableSectionRow = styled(StyledBaseRow)(({ theme }) => ({
  backgroundColor: theme.palette.surfaces.primary,
  cursor: "pointer",
}));

export const StyledTypography = styled(Typography)(() => ({
  fontSize: 14,
}));
